import React from "react";

/**
 * Skeletons premium (liventy) — shimmer suave em tom neutro zinc.
 * Uso: durante o initial-load das telas, em vez de spinners.
 */

const base = "relative overflow-hidden bg-zinc-100/80 rounded-md";
const shimmer =
  "after:absolute after:inset-0 after:-translate-x-full after:animate-[shimmer_1.4s_infinite] after:bg-gradient-to-r after:from-transparent after:via-white/60 after:to-transparent";

export const SkeletonLine = ({ w = "100%", h = 14, className = "" }) => (
  <div
    className={`${base} ${shimmer} ${className}`}
    style={{ width: w, height: h }}
  />
);

export const SkeletonBlock = ({ className = "" }) => (
  <div className={`${base} ${shimmer} ${className}`} />
);

export const SkeletonAvatar = ({ size = 40, className = "" }) => (
  <div
    className={`${base} ${shimmer} rounded-full ${className}`}
    style={{ width: size, height: size }}
  />
);

export const SkeletonStatCard = () => (
  <div className="bg-white rounded-xl p-4 border border-zinc-200/60 space-y-2.5">
    <div className="flex items-center gap-2">
      <SkeletonBlock className="w-3 h-3 rounded-sm" />
      <SkeletonLine w={92} h={11} />
    </div>
    <SkeletonLine w={60} h={26} />
    <SkeletonLine w="80%" h={11} />
  </div>
);

export const SkeletonStatsGrid = ({ count = 4 }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonStatCard key={i} />
    ))}
  </div>
);

export const SkeletonListRow = () => (
  <div className="flex items-center gap-3 p-4 bg-white rounded-xl border border-zinc-200/60">
    <SkeletonAvatar size={36} />
    <div className="flex-1 space-y-2">
      <SkeletonLine w="55%" h={13} />
      <SkeletonLine w="35%" h={11} />
    </div>
    <SkeletonBlock className="w-16 h-6 rounded-full" />
  </div>
);

export const SkeletonList = ({ count = 5 }) => (
  <div className="space-y-2">
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonListRow key={i} />
    ))}
  </div>
);

export const SkeletonPage = ({ stats = 4, rows = 5 }) => (
  <div className="space-y-6" data-testid="skeleton-page">
    <div className="space-y-2">
      <SkeletonLine w={180} h={22} />
      <SkeletonLine w={260} h={12} />
    </div>
    <SkeletonStatsGrid count={stats} />
    <SkeletonList count={rows} />
  </div>
);
